import { useEffect, useRef } from 'react';
import { useEditorStore } from '../store/editorStore';

export const useAutoSave = (interval = 30000) => {
  const { project } = useEditorStore();
  const timeoutRef = useRef<number>();

  useEffect(() => {
    const saveToLocal = () => {
      try {
        localStorage.setItem(`project-${project.id}`, JSON.stringify(project));
        console.log('Project auto-saved');
      } catch (err) {
        console.error('Auto-save failed:', err);
      }
    };

    // 保存初始状态
    saveToLocal();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [project, interval]);
};

export const loadFromLocal = (projectId: string) => {
  try {
    const saved = localStorage.getItem(`project-${projectId}`);
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (err) {
    console.error('Failed to load from local storage:', err);
  }
  return null;
};
